<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    v-bind:class="{ button__border: (!$vuetify.breakpoint.xs && border)}"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    border: {
      type: Boolean,
      default: () => true
    }
  }
};
</script>
<style scoped>
.button__border {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
